var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificaSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9010_50439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9992 63C51.7162 63 65.2679 49.1208 65.2679 32C65.2679 14.8792 51.7162 1 34.9992 1C18.2822 1 4.73047 14.8792 4.73047 32C4.73047 49.1208 18.2822 63 34.9992 63Z",
    fill: "#8BC34A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38034 32.6656C5.38034 15.5436 18.931 1.66557 35.6491 1.66557C43.8427 1.66557 51.2723 4.99942 56.723 10.4169C51.2225 4.60967 43.5236 1 34.9992 1C18.2822 1 4.73047 14.8792 4.73047 32C4.73047 40.7304 8.25499 48.6153 13.9253 54.2486C8.63847 48.6662 5.38034 41.0572 5.38034 32.6656Z",
    fill: "#AED581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9041 47.2242L43.3798 61.7828C56.0172 58.0592 65.2647 46.1389 65.2647 31.997C65.2647 31.7242 65.253 31.4544 65.2442 31.1816L51.4944 17.0996L28.9041 47.2242Z",
    fill: "url(#paint0_linear_9010_50439)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7721 47.7337C29.6626 47.7337 28.562 47.233 27.8213 46.2736L17.8889 33.4419C16.5979 31.772 16.8701 29.3495 18.5007 28.0274C20.1312 26.7052 22.4965 26.9871 23.7875 28.654L33.717 41.4857C35.008 43.1556 34.7357 45.5781 33.1052 46.9002C32.4173 47.4609 31.5918 47.7337 30.7721 47.7337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7662 47.7337C29.9466 47.7337 29.121 47.4608 28.4302 46.9002C26.8026 45.5781 26.5274 43.1526 27.8184 41.4857L46.208 17.729C47.4989 16.0621 49.8642 15.7803 51.4947 17.1024C53.1223 18.4246 53.3975 20.85 52.1065 22.5169L33.717 46.2736C32.9764 47.233 31.8786 47.7337 30.7662 47.7337Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9010_50439",
    x: 0.730469,
    y: 0,
    width: 68.5371,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9010_50439"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9010_50439",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9010_50439",
    x1: 38.0664,
    y1: 29.9765,
    x2: 59.1775,
    y2: 50.5897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#689F38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC34A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificaSuccess);
export default __webpack_public_path__ + "static/media/notifica_success.9756fbb73da39eb5a4da5aecc7daf051.svg";
export { ForwardRef as ReactComponent };